var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{ref:"select2",staticClass:"form-control",attrs:{"name":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }